import { FlexColPageContainer } from '../../../components/FlexColPageContainer';
import { getDebugRing } from '../../../lib/devUtils';
import { clx } from '../../../lib/utils';
import { ConfirmationForm } from './ConfirmationForm';

export const metadata = {
  title: 'Mood Log Completed | Patchooli',
  description: 'Mood Log Entry Completed | Patchooli',
};

export const MoodLogEntryStep5Page = () => {
  return (
    <FlexColPageContainer
      className={clx(getDebugRing('blue'), 'mx-auto max-w-md justify-normal gap-y-4')}
    >
      <ConfirmationForm />
    </FlexColPageContainer>
  );
};
